import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

import { SignIn } from '../../modules/auth/components/sign-in';
import { safeRedirectTo } from '../../modules/auth/safe-redirect-to';
import { setHtmlLoaderText, showHtmlLoader } from '../../ui/utils/html';

const AuthSignInRoute = () => {
  const navigate = useNavigate();
  const { redirectTo } = useSearch({ from: '/auth/signin' });

  return (
    <SignIn
      onSignedIn={() => {
        showHtmlLoader();
        setHtmlLoaderText('Loading account information ...');

        const target = safeRedirectTo(redirectTo);
        if (target) {
          navigate({ href: target });
          return;
        }
        navigate({ to: '/' });
      }}
    />
  );
};

const AuthSignInRouteSearchSchema = z.object({
  redirectTo: z.string().optional(),
});

export const Route = createFileRoute('/auth/signin')({
  validateSearch: (params) => AuthSignInRouteSearchSchema.parse(params),
  component: AuthSignInRoute,
});
